<template>
  <div class="flex flex-col flex-1 py-4 space-y-50px">
    <img
      :src="ASSET.BERKSHIRE_LOGO_TEXT_BA_DARKGRAY"
      class="min-w-213px"
      alt="Berkshire Logo"
    />
    <div class="mx-auto flex items-center space-x-3" :data-cy="DATA_CY.LOADING">
      <div class="ba-body">{{ loadingMessage }}</div>
      <Spinner class="h-26px" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ASSET, DATA_CY } from '~/constants/strings'

defineProps<{ loadingMessage: string }>()
</script>
